import { Box, Typography, Paper, Alert, Chip, Grid2 as Grid } from "@mui/material";
import { PageHeader } from "@/components/PageHeader";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { diagnosticsApi, type DxStudyListDto, type DxReportListDto } from "@/api/diagnostics";
import { errorMessage } from "@/api/client";
import { formatDateTime } from "@/shared/datetime";

export function RadiologyWorklistPage() {
  const studies = useQuery({ queryKey: ["dx-studies"], queryFn: () => diagnosticsApi.listStudies() });
  const reports = useQuery({ queryKey: ["dx-reports"], queryFn: () => diagnosticsApi.listReports() });

  const studyCols: GridColDef<DxStudyListDto>[] = [
    { field: "scheduledFor", headerName: "Scheduled", width: 180, valueGetter: v => v ? formatDateTime(v as string) : "" },
    { field: "status", headerName: "Status", width: 120, renderCell: p => <Chip size="small" label={p.row.status} variant="outlined" /> },
    { field: "studyInstanceUid", headerName: "DICOM UID", flex: 1, minWidth: 200 },
    { field: "id", headerName: "Study Id", width: 150, valueGetter: v => (v as string).slice(0, 8) },
  ];
  const reportCols: GridColDef<DxReportListDto>[] = [
    { field: "createdAt", headerName: "Created", width: 180, valueGetter: v => v ? formatDateTime(v as string) : "" },
    { field: "status", headerName: "Status", width: 120, renderCell: p => <Chip size="small" label={p.row.status} variant="outlined" /> },
    { field: "approvedBy", headerName: "Approved by", width: 150 },
    { field: "id", headerName: "Report Id", width: 150, valueGetter: v => (v as string).slice(0, 8) },
  ];

  return (
    <Box>
      <PageHeader breadcrumbs={["Diagnostics"]} title="Radiology worklist" />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>Studies</Typography>
            {studies.isError && <Alert severity="error" sx={{ mb: 1 }}>{errorMessage(studies.error)}</Alert>}
            <Box sx={{ height: 480 }}>
              <DataGrid rows={studies.data ?? []} columns={studyCols} loading={studies.isLoading} getRowId={r => r.id}
                disableRowSelectionOnClick pageSizeOptions={[25, 50]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} />
            </Box>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>Reports</Typography>
            {reports.isError && <Alert severity="error" sx={{ mb: 1 }}>{errorMessage(reports.error)}</Alert>}
            <Box sx={{ height: 480 }}>
              <DataGrid rows={reports.data ?? []} columns={reportCols} loading={reports.isLoading} getRowId={r => r.id}
                disableRowSelectionOnClick pageSizeOptions={[25, 50]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
